import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDraftIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 15",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0 1.77778C0 0.797222 0.797222 0 1.77778 0H6.22222V3.55556C6.22222 4.04722 6.61944 4.44444 7.11111 4.44444H10.6667V7.93611L8.25556 10.3472C7.96944 10.6333 7.76944 10.9889 7.67222 11.3806L7.15278 13.4611C7.08889 13.7167 7.10278 13.9833 7.18889 14.225L1.77778 14.2222C0.797222 14.2222 0 13.425 0 12.4444V1.77778ZM10.6667 3.55556H7.11111V0L10.6667 3.55556ZM15.2722 6.54722L15.6722 6.94722C16.1056 7.38056 16.1056 8.08333 15.6722 8.51944L14.8556 9.33611L12.8833 7.36389L13.7 6.54722C14.1333 6.11389 14.8361 6.11389 15.2722 6.54722ZM8.66389 11.5833L12.2528 7.99444L14.225 9.96667L10.6361 13.5528C10.5222 13.6667 10.3806 13.7472 10.2222 13.7861L8.55278 14.2028C8.4 14.2417 8.24167 14.1972 8.13056 14.0861C8.01944 13.975 7.975 13.8167 8.01389 13.6639L8.43056 11.9944C8.46944 11.8389 8.55 11.6944 8.66389 11.5806V11.5833Z"
	})
});
export default SvgDraftIcon;
